<template>
  <div class="user-bar">
    <el-dropdown class="user panel-item" trigger="click">
      <div class="user-avatar">
        <el-avatar :size="30">{{ nickName }}</el-avatar>
        <label>{{ userName }}</label>
        <el-icon class="el-icon-right"><el-icon-arrow-down /></el-icon>
      </div>
      <template #dropdown>
        <el-dropdown-menu>
          <el-dropdown-item @click="clearCache">清除缓存</el-dropdown-item>
          <el-dropdown-item @click="this.$refs.changePsd.open()">修改密码</el-dropdown-item>
          <el-dropdown-item @click="this.$refs.timeConfig.open()">设置超时时间</el-dropdown-item>
          <el-dropdown-item divided @click="outLogin">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </template>
    </el-dropdown>
  </div>
  <changePsd ref="changePsd" />
  <timeConfig ref="timeConfig" />
</template>

<script>
import storage from '@/utils/storage'
import changePsd from './changePsd.vue';
import timeConfig from './timeConfig.vue';

export default {
  methods:{
    outLogin(){
      storage.remove("token");
      setTimeout(()=>{ this.$router.replace({ path: '/login' }) }, 100)
    },
    clearCache(){
      this.$confirm('清除缓存会清除所有登录信息，包括记住的密码以及登录状态，是否继续？','提示', {
        type: 'info',
      }).then(() => {
        storage.clear();
        setTimeout(()=>{ this.$router.replace({path: '/login'}) }, 300)
      }).catch(() => { })
    }
  },
  computed:{
    userName(){
      return "管理员";
    },
    nickName(){
      return "A";
    },
    balance(){
      return this.$store.state.app.balance;
    }
  },
  components:{
    changePsd,
    timeConfig
  }
}
</script>

<style lang="scss" scoped>
.user-bar {
  display: flex;
  align-items: center;
  height: 100%;
  .panel-item {
    padding: 0 10px;
    cursor: pointer;
    height: 100%;
    display: flex;
    align-items: center;
    &:hover {
      background: rgba(0, 0, 0, 0.1);
    }
    i {
      font-size: 16px;
    }
  }
  .user-avatar {
    height:49px;
    display: flex;
    align-items: center;
    label {
      display: inline-block;
      margin-left:5px;
      font-size: 12px;
      cursor:pointer;
    }
  }
  
}
.el-dropdown-item{
  background: #f00538;
}
</style>